import type { PageComponent } from '../../router'
import { LoginPageController } from './LoginPageController'
import { loginPageTemplate } from './loginPageTemplates'

/** Mounts the login artwork and tears down its animation when leaving the page. */
const LoginPage: PageComponent = {
	mount({ containerEl, signal }) {
		containerEl.innerHTML = loginPageTemplate()
		const root = containerEl.querySelector<HTMLElement>('#login-page')
		if (!root) throw new Error('Incomplete login page')

		const controller = new LoginPageController(root)
		signal.addEventListener('abort', () => controller.dispose(), {
			once: true,
		})
		return controller
	},
}

export default LoginPage
